import { FC } from 'react';

import { GuardianContactDetails } from 'store/candidate/types';
import { useGetFamilyRelationshipsQuery } from 'store/family-relationship/familyRelationshipAPI';

import { Divider, SelectField, TextField } from '@britishcouncil/react-solas-ors3';
import { FormFields } from '@britishcouncil/react-forms';

export const ParentContactDetailsFields: FC<{ fields: FormFields<GuardianContactDetails> }> = ({ fields }) => {
  const { data: familyRelationships } = useGetFamilyRelationshipsQuery();

  return (
    <>
      <h2>Parent/guardian contact details:</h2>
      <SelectField
        label="Relationship to the child *"
        {...fields.familyRelationshipId}
        options={familyRelationships || []}
        showColon={false}
      />
      <TextField label="Your mobile number *" {...fields.mobile} showColon={false} />
      <TextField label="Alternative contact number" {...fields.telephone} showColon={false} />
      <Divider />
    </>
  );
};
